import { MaskedInput, MaskedInputExtendedProps, Text } from 'grommet'

interface TimeInputProps extends MaskedInputExtendedProps {
  name?: string
  label: string
  errorMessage?: string
  value: string
  setValue: (value: string) => void
}

export const TimeInput = ({ label, setValue, value, ...rest }: TimeInputProps) => {
  return (
    <>
      {label && (
        <Text margin={{ bottom: '2px' }} style={{ fontSize: '14px', fontWeight: 500 }}>
          {label}
        </Text>
      )}

      <MaskedInput
        mask={[
          {
            length: [1, 2],
            options: Array.from({ length: 12 }, (v, k) => k + 1),
            placeholder: 'hh',
            regexp: /^1[0,1-2]$|^0?[1-9]$|^0$/
          },
          { fixed: ':' },
          {
            length: 2,
            options: ['00', '15', '30', '45'],
            placeholder: 'mm',
            regexp: /^[0-5][0-9]$|^[0-9]$/
          },
          { fixed: ' ' },
          {
            length: 2,
            options: ['am', 'pm'],
            placeholder: 'ap',
            regexp: /^[ap]m$|^[AP]M$|^[aApP]$/
          }
        ]}
        onChange={selectedVal => {
          setValue(selectedVal.target?.value)
        }}
        value={value}
        {...rest}
      />
    </>
  )
}
